/**
 * 알림 항목 클릭 시 이동 방식 결정 (JCG-3601) — 순수 모듈(테스트 대상).
 *
 * 링크가 **현재 문서(경로+쿼리)** 를 가리키면 `location.hash` 만 바꿔야 한다. Next `router.push` 는 같은 문서의
 * 해시 이동에서 `hashchange` 를 쏘지 않아 댓글 딥링크 훅(`useCommentDeepLink`)이 재실행되지 않기 때문이다
 * (ui-patterns/comments.md §12-3). 복원 게시판처럼 쿼리(`?session=&post=`)가 문서를 가르는 경우가 있어
 * pathname 만이 아니라 search 까지 비교한다.
 */

export type NotificationNavigation =
  | { kind: "hash"; hash: string }
  | { kind: "push"; href: string };

export function resolveNotificationNavigation(
  link: string,
  currentPathAndSearch: string,
): NotificationNavigation {
  const hashIndex = link.indexOf("#");
  const target = hashIndex >= 0 ? link.slice(0, hashIndex) : link;
  const hash = hashIndex >= 0 ? link.slice(hashIndex + 1) : "";
  if (hash && (target === "" || target === currentPathAndSearch)) {
    return { kind: "hash", hash: `#${hash}` };
  }
  return { kind: "push", href: link };
}
